import { render, staticRenderFns } from "./SlidingBayDescription.vue?vue&type=template&id=e2ef2a0c&scoped=true"
import script from "./SlidingBayDescription.vue?vue&type=script&lang=ts"
export * from "./SlidingBayDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ef2a0c",
  null
  
)

export default component.exports